import SpriteSymbol from "../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-2023",
  "use": "icon-2023-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" fill=\"currentColor\" class=\"qi-2023\" viewBox=\"0 0 16 16\" id=\"icon-2023\">\n  <path d=\"M13.935 6.893 10.74 1.667a.256.256 0 0 0-.438 0L7.107 6.893a.257.257 0 0 0 .22.391h6.389c.2 0 .323-.22.219-.391zm-3.414-.784a.292.292 0 1 1 0-.585.292.292 0 0 1 0 .585zm.198-.85h-.396l-.162-1.157a.363.363 0 1 1 .72 0l-.162 1.157zm-2.111 7.314 6.353-1.631-11.186-2.39 2.459 2.078L0 12.292l9.089 3.481L16 14.474z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol